import { maximumTaskSupportUsers } from '../taskSupport'
import { AnchoredSelect } from './AnchoredSelect'
import type { UserSelectOption } from './SearchableUserSelect'

interface Props {
  taskTitle: string
  owner: string
  users: string[]
  options: UserSelectOption[]
  canManage: boolean
  onChange: (users: string[]) => void
}

export function TaskSupportUsers({ taskTitle, owner, users, options, canManage, onChange }: Props) {
  const available = options.filter(option => option.value !== owner && !users.includes(option.value))
  const addOptions = available.map(option => ({
    value: option.value,
    label: option.name,
    description: option.profile,
  }))

  return <div className="task-support-users">
    {canManage && users.length < maximumTaskSupportUsers && addOptions.length > 0 && <AnchoredSelect
      value=""
      options={addOptions}
      onChange={user => onChange([...users, user])}
      ariaLabel={`Adicionar suporte a ${taskTitle}`}
      placeholder="+ Adicionar Suporte"
      className="task-support-add"
    />}
    {users.length > 0 && <div className="task-support-list" aria-label={`Suportes de ${taskTitle}`}>
      {users.map(user => {
        const account = options.find(option => option.value === user)
        return <span key={user} title={account ? `${account.name} · ${account.profile}` : user}>
          {account?.name ?? user}
          {canManage && <button type="button" onClick={() => onChange(users.filter(item => item !== user))} aria-label={`Remover ${account?.name ?? user} do suporte`}>×</button>}
        </span>
      })}
    </div>}
    {canManage && users.length >= maximumTaskSupportUsers && <small className="task-support-limit">Limite de 3 suportes</small>}
  </div>
}
